/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from './tooltip';
import classNames from 'classnames';
import _ from 'underscore';

export class FormRow extends React.Component {
    static initClass() {
      this.propTypes = {
        title: PropTypes.string,
        className: PropTypes.string,
        tooltip: PropTypes.string,
        tooltipUrl: PropTypes.string,
        tooltipLabel: PropTypes.string,
        required: PropTypes.bool,
        labelFor: PropTypes.string,
  
        // Theme-related things
        wrapperElement: PropTypes.elementType.isRequired,
        labelElement: PropTypes.elementType.isRequired,
        labelClassName: PropTypes.string
      };
  
      this.defaultProps = {
        wrapperElement: 'label',
        labelElement: 'span',
        labelClassName: ''
      };
    }

    render() {
      let required_tag; let title_row;
      const tooltip_tag = this.props.tooltip ?
        <Tooltip label={this.props.tooltipLabel}
                  url={this.props.tooltipUrl}
                  text={this.props.tooltip} /> : undefined;

      if (this.props.required) { required_tag = <sup className="required">Required</sup>; }
      if (_.isBlank(this.props.title)) {
        title_row = <this.props.labelElement className={this.props.labelClassName} htmlFor={this.props.labelElement === 'label' ? this.props.labelFor : undefined }/>;
      } else {
        title_row = <this.props.labelElement className={this.props.labelClassName} htmlFor={this.props.labelElement === 'label' ? this.props.labelFor : undefined }>
          {this.props.title}{required_tag}{tooltip_tag}
        </this.props.labelElement>;
      }

      const wrapper_class = classNames(this.props.wrapperClassName, this.props.className);

      return <this.props.wrapperElement className={wrapper_class}
                                  htmlFor={this.props.wrapperElement === 'label' ? this.props.labelFor : undefined }>
        {title_row}
        {this.props.children}
      </this.props.wrapperElement>;
    }
  }
FormRow.initClass();
